import type { SVGProps } from 'react';

const SvgEMobiledata = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M16 9V7H8v10h8v-2h-6v-2h6v-2h-6V9z" />
  </svg>
);
export default SvgEMobiledata;
